"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationReference = exports.PeriodStartEndDates = exports.ReportStartEndDates = exports.StartEndDates = exports.extractReportIds = exports.validate = exports.GenerateRangesRequest = exports.ReportColumnTypes = exports.ComparisonTypes = exports.ReportTimeframes = exports.ReportTypes = void 0;
const Errors_1 = require("./Errors");
exports.ReportTypes = {
    APAging: "AP Aging",
    BalanceSheet: "Balance Sheet",
    CashFlow: "Cash Flow",
    IncomeStatement: "Income Statement",
    PLComparison: "P&L Comparison",
};
exports.ReportTimeframes = {
    Week: "Week",
    Month: "Month",
    Quarter: "Quarter",
    Year_to_Date: "Year to Date",
    Year: "Year",
};
exports.ComparisonTypes = {
    Prior_Period: "Prior Period",
    Year_Over_Year: "Year Over Year",
};
exports.ReportColumnTypes = {
    Data: "Data",
    Total: "Total",
    Difference: "Difference",
    Budget: "Budget",
};
class GenerateRangesRequest {
    constructor(timeframe, weekStart, configData) {
        this.includeNames = true;
        this.timeframe = timeframe;
        this.weekStart = weekStart;
        this.configData = configData;
    }
}
exports.GenerateRangesRequest = GenerateRangesRequest;
//TODO: move to reportUtil
function validate(request) {
    const numLocations = request?.locations?.length;
    if (!numLocations || numLocations < 1) {
        throw Errors_1.ReportErrors.requiredLocation();
    }
    if (!request.timeframe && numLocations > 1) {
        throw Errors_1.ReportErrors.unsupportedMultiLocations();
    }
    else if (request.timeframe && numLocations > 1 && !request.consolidated) {
        // Special case - non-consolidated needs to have different validations (consolidated is the same as single location)
        validateSideBySideMultiLocation(request);
    }
    if (request.baseId && (request.startDate || request.endDate || request.limit || request.timeframe)) {
        throw Errors_1.ReportErrors.invalidParamsWithBaseId();
    }
    if (!request.baseId) {
        if (!request.type) {
            throw Errors_1.ReportErrors.requiredType();
        }
        else if (request.timeframe) {
            validateWithTimeframe(request);
        }
        else if (!request.startDate && !request.limit) {
            throw Errors_1.ReportErrors.requiredStartDateOrLimit();
        }
    }
    if (request.total && request.difference) {
        throw Errors_1.ReportErrors.totalDifference();
    }
    if (request.comparison) {
        validateComparison(request, request.comparison);
    }
}
exports.validate = validate;
function validateComparison(request, comp) {
    if (!comp.comparisonType) {
        throw Errors_1.ReportErrors.requiredComparisonType();
    }
    if (request.total) {
        throw Errors_1.ReportErrors.invalidTotalWithComparison();
    }
    if (request.breakdownPeriods) {
        throw Errors_1.ReportErrors.invalidBreakdownWithComparison();
    }
    if (comp.comparisonPeriods || comp.comparisonPeriods === 0) {
        if (comp.comparisonPeriods < Errors_1.ReportErrors.comparisonPeriodsLowerLimit) {
            throw Errors_1.ReportErrors.comparisonPeriodsTooSmall(comp.comparisonPeriods);
        }
        if (comp.comparisonPeriods > Errors_1.ReportErrors.comparisonPeriodsUpperLimit) {
            throw Errors_1.ReportErrors.comparisonPeriodsTooLarge(comp.comparisonPeriods);
        }
        if (request.difference) {
            if (includeBudgets(request)) {
                throw Errors_1.ReportErrors.invalidDifferenceBudgetsComparison();
            }
            if (comp.comparisonPeriods > 1) {
                throw Errors_1.ReportErrors.comparisonPeriodsInvalidDifference(comp.comparisonPeriods);
            }
        }
    }
}
function validateSideBySideMultiLocation(request) {
    if (request.total || request.difference || request.breakdownPeriods || request.reverse || request.comparison) {
        throw Errors_1.ReportErrors.unsupportedOptionsSideBySide();
    }
}
function validateWithTimeframe(request) {
    // These validations cover the new P&L based validations, which are done when a timeframe is specified
    // Soon these will be required (once timeframe is required)
    validateStartDate(request);
    if (request.limit) {
        throw Errors_1.ReportErrors.invalidLimit();
    }
    if (request.budgets && request.timeframe === exports.ReportTimeframes.Week) {
        throw Errors_1.ReportErrors.invalidBudgetsWithWeek();
    }
    if (request.budgets && request.total) {
        throw Errors_1.ReportErrors.invalidBudgetsWithTotal();
    }
    // We have already verified that a start date exists, so we'll not check for endDate (custom range) and comparison
    if (request.endDate && request.comparison) { // custom range AND comparison
        throw Errors_1.ReportErrors.invalidEndDateWithComparison();
    }
    else if (!request.endDate && !request.comparison) { // no custom range or comparison (single period)
        if (request.timeframe === exports.ReportTimeframes.Week || request.timeframe === exports.ReportTimeframes.Month) {
            if (request.breakdownPeriods) {
                throw Errors_1.ReportErrors.invalidBreakdown(request.timeframe);
            }
            if (request.reverse) {
                throw Errors_1.ReportErrors.invalidReverse(request.timeframe);
            }
            if (request.total) {
                throw Errors_1.ReportErrors.invalidTotal(request.timeframe);
            }
        }
        validateParamsWithoutComparison(request);
    }
    else if (request.comparison) {
        if (request.comparison.comparisonType === exports.ComparisonTypes.Prior_Period
            && (request.timeframe === exports.ReportTimeframes.Year_to_Date || request.timeframe === exports.ReportTimeframes.Year)) {
            throw Errors_1.ReportErrors.invalidCompareType(request.comparison.comparisonType, request.timeframe);
        }
        // Other validations are handled by validateComparison function - eventually we might need to call this here....
    }
    else if (request.endDate) { // custom range without comparison
        if (request.timeframe === exports.ReportTimeframes.Year_to_Date) {
            throw Errors_1.ReportErrors.invalidEndDate(request.timeframe);
        }
        validateParamsWithoutComparison(request);
        //TODO: need to guess at number of periods to validate
        // For now these are mostly handled in the hone-reporting code (once the data has been gathered)
        // It would be great to move validations here eventually...
    }
}
function validateParamsWithoutComparison(request) {
    if (request.timeframe === exports.ReportTimeframes.Week && request.difference) {
        throw Errors_1.ReportErrors.invalidDifference(request.timeframe);
    }
    if (request.total && !request.breakdownPeriods) {
        throw Errors_1.ReportErrors.invalidTotalWithoutBreakdown(request.timeframe);
    }
    if (request.reverse && !request.breakdownPeriods) {
        throw Errors_1.ReportErrors.invalidReverseWithoutBreakdown(request.timeframe);
    }
    if (request.difference && request.breakdownPeriods) {
        throw Errors_1.ReportErrors.invalidDifferenceBreakdownPeriods();
    }
    if (request.difference && !includeBudgets(request)) {
        throw Errors_1.ReportErrors.invalidDifferenceWithoutBudgets(request.timeframe);
    }
}
function validateStartDate(request) {
    if (!request.startDate && request.timeframe !== exports.ReportTimeframes.Year_to_Date) {
        throw Errors_1.ReportErrors.requiredStartDate(request.timeframe);
    }
    if (request.startDate && request.timeframe === exports.ReportTimeframes.Year_to_Date) {
        throw Errors_1.ReportErrors.invalidStartDate(request.timeframe);
    }
}
function includeBudgets(request) {
    return request.budgets?.include;
}
//TODO: move to reportUtil
function extractReportIds(dates) {
    const reportIds = new Set();
    dates?.forEach(date => visit(date, reportIds));
    return [...reportIds];
}
exports.extractReportIds = extractReportIds;
function visit(date, reportIds) {
    if (!date) {
        return;
    }
    if (date.reportId && includeReportId(date.reportId, date.type)) {
        reportIds.add(date.reportId);
    }
    date.groupedDates?.forEach(date => visit(date, reportIds));
}
function includeReportId(reportId, type) {
    return !reportId.includes("budget") && (!type || type === exports.ReportColumnTypes.Data);
}
// Report Models
class StartEndDates {
    constructor(start = "", end = "", name) {
        this.start = start;
        this.end = end;
        this.name = name;
    }
}
exports.StartEndDates = StartEndDates;
class ReportStartEndDates extends StartEndDates {
    constructor(startDate, start, endDate, end) {
        super();
        this.startDate = startDate;
        this.start = start;
        this.endDate = endDate;
        this.end = end;
    }
}
exports.ReportStartEndDates = ReportStartEndDates;
class PeriodStartEndDates extends StartEndDates {
    constructor(start, end, reportId, groupedDates) {
        super(start, end);
        this.reportId = reportId;
        this.groupedDates = groupedDates;
    }
}
exports.PeriodStartEndDates = PeriodStartEndDates;
class LocationReference {
    constructor(name, id) {
        this.name = name;
        this.id = id;
    }
}
exports.LocationReference = LocationReference;
//# sourceMappingURL=Reports.js.map